import { createSelector } from 'reselect';
import { SIGN_UP_KEY } from '../constants';

export const shouldShowLoginModal = createSelector(
    (state) => state[SIGN_UP_KEY],
    (signUpState) => signUpState.shouldShowLoginModal
);

export const sawLoginModal = createSelector(
    (state) => state[SIGN_UP_KEY],
    (signUpState) => signUpState.sawLoginModal
);

export const cssTransitionSelector = createSelector(
    (state) => state[SIGN_UP_KEY],
    (signUpState) => signUpState.cssTransition
);
